import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { userService, auth } from '../../../../../services';
import {
	getAccountDetails,
	getMyMemberships,
} from '../../../../../Redux/Actions/EndUser/AccountDetailsActions';
import './MembershipsPage.scss';
import DownloadMembership from '../DownloadMembership/DownloadMembership';
import MembershipDetails from '../MembershipDetails/MembershipDetails';
import AuthorizedMembers from '../AuthorizedMembers/AuthorizedMembers';
import SpecialRanger from '../SpecialRanger/SpecialRanger';
import { history } from '../../../../../helpers/history';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

class MembershipsPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			user: {},
			tabs: [
				{
					id: 'Membership Details',
					label: 'Membership Details'
				},
				{
					id: 'regionAndDistrict',
					label: 'Region & District Information'
				},
				{
					id: 'Authorized Members',
					label: 'Authorized Members'
                },
                {
                    id: 'Download Member Card',
                    label: 'Download Member Card'
                },
				{
					id: 'goBack',
					label: 'Back to Dashboard'
				}
			],
			mobileTabs: [
				{
					id: 'Membership Details',
					label: 'Membership Details'
				},
				{
					id: 'regionAndDistrict',
					label: 'Region & District Information'
				},
				{
					id: 'Authorized Members',
					label: 'Authorized Members'
				},
				{
					id: 'goBack',
					label: 'Back to Dashboard'
				}
			],
			activeTab: 'Membership Details',
			loading: true
		};

		if (!auth.isAuthenticated()) {
			this.props.history.push('/');
		}
	}

	componentDidMount() {
		if (isMobile) {
			this.setState({
				tabs: [
					{
						id: 'Membership Details',
						label: 'Membership Details'
					},
					{
						id: 'regionAndDistrict',
						label: 'Region & District Information'
					},
					{
						id: 'Authorized Members',
						label: 'Authorized Members'
					},
					{
						id: 'goBack',
						label: 'Back to Dashboard'
					}
				]
			})
        }
	}

	getUserProfile() {
		var userName = auth.getAuthUserEmail();
		if (userName) {
			userService.getUserProfile(userName).then(({ data }) => {
				this.setState({ user: data, loading: false });
			});
		}
	}

	profileUpdated = (profile) => {
		this.setState({ user: profile });
	};

	selectTab = (event) => {
		const target = event.target;
		this.setState({ activeTab: target.id });
	};

	tabsContent = () => {
		switch (this.state.activeTab) {
			case 'Membership Details':
				return <MembershipDetails  />;
			case 'regionAndDistrict':
				return <SpecialRanger/>
			case 'Authorized Members':
                return <AuthorizedMembers />;
            case 'Download Member Card':
                return <DownloadMembership />;
			case 'goBack':
				return history.push('/dashboard');
			default:
				return null;
		}
	};

	render() {
		return (
			<div className="membership-details">
				<div className="membership-details-container">
				{/* <h1 className="pt-3 pb-3">{this.state.activeTab }</h1> */}
					<div className="cols">
						<div className="col-md-4 col-sm-12 col-left">
							<ul className="list-group account-tabs">
								{
									this.state.tabs.map((tab, index) => {
									const cls = '';

									return (
										<li className="list-group-item" key={index}>
											<a className={tab.id == this.state.activeTab ? `${cls} active` : cls}
											onClick={this.selectTab}
											id={tab.id}
											key={index}
											tabIndex="0"
											>{tab.label}</a>
										</li>
									);
								})}
							</ul>
						</div>
						<div className="col-md-8 col-sm-12 col-right">{this.props.accountDetails.selectedMember.membershipId ? this.tabsContent() : history.push('/dashboard')}</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
        accountDetails: state.accountDetails,
		
	};
}

export default withRouter(connect(mapStateToProps, null)(MembershipsPage));
